import { render, staticRenderFns } from "./SubirVideos.vue?vue&type=template&id=496126a1&scoped=true"
import script from "./SubirVideos.vue?vue&type=script&lang=js"
export * from "./SubirVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496126a1",
  null
  
)

export default component.exports